export const urls = {
  login: () => '/oauth/token',
  getOtp: () => `/api/v1/otp/send`,
  changePassword: () => `/api/v1/user/change-password`,
};
